import WebSocketService from "@/WebSocketService";

//ws = web socket
function Install(Vue) {
    Vue.ws = WebSocketService;
    Vue.prototype.$ws = WebSocketService;
}

export default Install
